export default 0.282866535386;
